import type { SeriesCommentAttributes, UserAttributes } from '@/server/models'

import { SQL, type SQLFragment } from '@/client/query'

import {
  type AssociationDefinitions,
  type GroupBy,
  type IncludeAssociations,
  includeAssociationsToSql,
  makeQueryModelV2,
  type QueryOrder,
  queryGroupByToSQL,
  queryOrderToSQL,
} from './common'
import SeriesQ from './SeriesQ'
import UserQ from './UserQ'

const SeriesCommentQ = {
  ...makeQueryModelV2<SeriesCommentAttributes>('series_comment')([
    'id',
    'series_id',
    'user_id',
    'message',
    'message_safe',
    'hidden_at',
    'created_at',
    'deleted_at',
  ]),

  associations: (): AssociationDefinitions => ({
    User: {
      query: UserQ,
      foreignKey: UserQ.id,
      sourceKey: SeriesCommentQ.user_id,
    },
    Series: {
      query: SeriesQ,
      foreignKey: SeriesQ.id,
      sourceKey: SeriesCommentQ.series_id,
    },
  }),

  where: (
    {
      paranoid = true,
      seriesId,
      userId,
      include = [],
      groupBy = null,
      order = null,
      limit = null,
    }: {
      paranoid?: boolean
      seriesId?: number | null | SQLFragment<number>
      userId?: number | null | SQLFragment<number>
      include?: IncludeAssociations
      groupBy?: GroupBy | null
      order?: QueryOrder | null
      limit?: number | null
    },
    customWhere: SQLFragment<unknown> | null = null
  ): SQLFragment<SeriesCommentAttributes> => SQL`
        FROM ${SeriesCommentQ}
        ${includeAssociationsToSql(SeriesCommentQ, include)}
        WHERE
            ${paranoid ? SQL`${SeriesCommentQ.deleted_at} IS NULL AND` : SQL``}
            ${seriesId != null ? SQL`${SeriesCommentQ.series_id} = ${seriesId} AND` : SQL``}
            ${userId != null ? SQL`${SeriesCommentQ.user_id} = ${userId} AND` : SQL``}
            ${customWhere != null ? customWhere : SQL`TRUE`}
        ${queryGroupByToSQL(groupBy)}
        ${queryOrderToSQL(order)}
        ${limit != null ? SQL`LIMIT ${limit}` : SQL``}
    `,

  getAuthor: (): SQLFragment<UserAttributes> =>
    SQL`${UserQ.where({
      id: SeriesCommentQ.user_id,
    })}`,

  getSeries: (): SQLFragment<UserAttributes> =>
    SQL`${SeriesQ.where({
      id: SeriesCommentQ.series_id,
    })}`,
}

export default SeriesCommentQ
